/* eslint-disable padded-blocks */
import mixpanel from 'mixpanel-browser';
import { environment } from 'utils/environment.utils';

export interface IMixpanelEventMetadata {
    'Product Area Origin'?: string;
    Element?: string;
    Group?: string;
    Step?: string;
    Label?: string;
    Text?: string;
    Scenario?: string;
    'Time Responsavel'?: string;
    specificProperties?: Record<string, any> | 'Não se aplica';
}

interface ITrackingRepository {
    sendMixpanelEvent(event: string, metadata?: IMixpanelEventMetadata): void;
    sendGoogleAnalyticsEvent(event: string, metadata?: Record<string, any>): void;
}

class TrackingRepository implements ITrackingRepository {
    /**
     *
     * @param event
     * @param metadata
     */
    public sendMixpanelEvent(event: string, metadata: Record<string, any> = {}) {
        this.mixpanel.track(event, { ...metadata });
    }

    /**
     *
     * @param event
     */
    public sendGoogleAnalyticsEvent(event: string, metadata: Record<string, any> = {}) {
        if (event.toLowerCase() === 'pageview') {
            this.analytics('set', 'page', window.location.pathname + window.location.search);
        }
        this.analytics('send', event, { ...metadata, url: window.location.href });
    }

    private get analytics() {
        return window.ga;
    }

    private get mixpanel() {
        return mixpanel.init(environment.MIXPANEL_API_KEY || '', {}, 'mixpanelToro');
    }
}

export const trackingRepository: ITrackingRepository = new TrackingRepository();
